import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import headermenus from '../routes/headermenus';
import { authuser, logout } from '../store/Authentication/AuthSlice';
import logouticon from '../assets/images/header-menus/logout-icon.svg'



const HeaderMenus = ({ hide }) => {
    const loginedUser = useSelector(authuser);
    const userrole = loginedUser?.userroles;
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const logOut = () => {
        dispatch(logout())
            .then((res) => {
                localStorage.clear();
                navigate('/auth/login')
            })
            .catch((err) => {
                console.error(err);
            });
    };
    const kamHeaderList =
        [
            {
                path: 'logout',
                slug: 'logout',
                name: 'Logout',
                menuicon: logouticon,
                role: ['kam'],
                pagetitle: 'Logout'
            }

        ]
    return (
        <>
            <ul
                className="py-3 notranslate"
                translate="no"
                data-gramm="false"
                data-gramm_editor="false"
                data-enable-grammarly="false"
            >
                {
                    (userrole === "kam" ? kamHeaderList : headermenus).map((menu, index) => {
                        return menu.path !== 'logout' ?
                            <li key={index}>
                                <NavLink to={menu.navTo || menu.path} className='flex items-center py-4 px-5 text-sm font-semibold hover:bg-[#F7F5FF] relative bg-white text-secondary' onClick={hide}>
                                    <img src={menu.menuicon} alt={menu.name} />
                                    <span className='block mx-4'>{menu.name}</span>
                                </NavLink>
                            </li>
                            :
                            <li key={index} onClick={logOut}>
                                <div className='cursor-pointer flex items-center py-4 px-5 text-sm font-semibold hover:bg-[#F7F5FF] relative bg-white text-secondary'>
                                    <img src={menu.menuicon} alt={menu.name} />
                                    <span className='block mx-4'>{menu.name}</span>
                                </div>
                            </li>
                    })
                }
            </ul>
        </>
    )
}

export default HeaderMenus